import ShopService from 'components/shop/ShopService';

import {
    SET_CART,
    ADD_PRODUCT,
    DELETE_PRODUCT,
    CHANGE_AMOUNT,
} from 'components/shop/actions';

const initialState = {};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CART: {
            const {
                cart,
            } = action.payload;

            return cart;
        }
        case ADD_PRODUCT: {
            const {
                productSlug,
            } = action.payload;

            if (state[productSlug]) {
                return state;
            }

            const product = ShopService.getProduct(productSlug);

            return {
                ...state,
                [productSlug]: {
                    productSlug,
                    price: product.price,
                    amount: 1,
                },
            };
        }
        case DELETE_PRODUCT: {
            const {
                productSlug,
            } = action.payload;

            const copy = { ...state };
            delete copy[productSlug];

            return copy;
        }
        case CHANGE_AMOUNT: {
            const {
                productSlug,
                amount,
            } = action.payload;

            return {
                ...state,
                [productSlug]: {
                    ...state[productSlug],
                    amount,
                },
            };
        }
        default: {
            return state;
        }
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./resources/components/shop/reducers/cart.js